/**
 * Валидирует название характеристики вариации
 * @param newName - новое название характеристики
 * @param position - позиция характеристики ('first' | 'second')
 * @param _currentCharacteristics - не используется (оставлен для совместимости вызовов)
 * @param otherVariationName - название другой характеристики вариации
 * @returns строка с ошибкой или null если валидация прошла успешно
 */
export const validateVariationName = (
  newName: string,
  position: 'first' | 'second',
  _currentCharacteristics: unknown,
  otherVariationName?: string
): string | null => {
  const trimmedName = newName.trim()

  if (!trimmedName) {
    return 'Название характеристики не может быть пустым'
  }

  // Проверяем дублирование с другой характеристикой вариации
  if (
    otherVariationName &&
    otherVariationName.toLowerCase() === trimmedName.toLowerCase()
  ) {
    return 'Нельзя использовать одинаковые названия для характеристик вариации'
  }

  return null
}

/**
 * Валидирует название новой характеристики
 * @param name - название характеристики
 * @param existingCharacteristics - все характеристики товара, включая обязательные
 * @param firstVariationName - название первой характеристики вариации
 * @param secondVariationName - название второй характеристики вариации
 * @returns строка с ошибкой или null если валидация прошла успешно
 */
export const validateCharacteristicName = (
  name: string,
  existingCharacteristics?: Array<{ name?: string }>,
  firstVariationName?: string,
  secondVariationName?: string
): string | null => {
  const trimmedName = name.trim()

  if (!trimmedName) {
    return 'Заполните название характеристики'
  }

  const isDuplicate = existingCharacteristics?.some(
    (char) => char?.name?.trim().toLowerCase() === trimmedName.toLowerCase()
  )

  if (isDuplicate) {
    return 'Характеристика с таким названием уже добавлена'
  }

  // Проверяем дублирование с характеристиками вариаций
  if (firstVariationName && firstVariationName.toLowerCase() === trimmedName.toLowerCase()) {
    return 'Характеристика с таким названием уже используется для вариаций'
  }

  if (secondVariationName && secondVariationName.toLowerCase() === trimmedName.toLowerCase()) {
    return 'Характеристика с таким названием уже используется для вариаций'
  }

  return null
}

/**
 * Валидирует значение характеристики
 * @param value - значение характеристики
 * @returns строка с ошибкой или null если валидация прошла успешно
 */
export const validateCharacteristicValue = (value: string): string | null => {
  const trimmedValue = value.trim()

  if (!trimmedValue) {
    return 'Заполните значение характеристики'
  }

  return null
}

/**
 * Валидирует возможность добавления второй характеристики вариации
 * @param variations - массив вариаций
 * @returns строка с ошибкой или null если валидация прошла успешно
 */
export const validateSecondVariationCharacteristic = (
  variations: any[]
): string | null => {
  if (!variations.some((item) => item.firstCharacteristicValue)) {
    return 'Для добавления 2-ой характеристики, укажите хотя бы одно значение для 1-ой характеристики'
  }

  return null
}

/**
 * Капитализирует первую букву строки
 * @param str - строка для капитализации
 * @returns строка с заглавной первой буквой
 */
export const capitalizeFirstLetter = (str: string): string => {
  if (!str) return str
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}